import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BrandSlice {
  activeBrand: string,
  activeLanguage: string,
  allLanguages: string[]
}

const initialState: BrandSlice = {
  activeBrand: '',
  activeLanguage: '',
  allLanguages: ['en','es']
};

export const brandSlice = createSlice({
  name: 'brand',
  initialState: initialState,
  reducers: {
    setActiveBrand: (state, action: PayloadAction<string>) => {
      state.activeBrand = action.payload;
    },
    setActiveLanguage: (state, action: PayloadAction<string>) => {
      state.activeLanguage = action.payload;
    },
    setAllLanguages: (state, action: PayloadAction<string[]>) => {
      state.allLanguages = action.payload;
    }
  }
});

export const { setActiveBrand, setActiveLanguage, setAllLanguages } = brandSlice.actions;
export default brandSlice.reducer;
